import './style.css'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'
import { compose, withState } from 'recompose'
import * as Icons from 'components/Utils/Icons'

class UpdateStatus extends Component {
  static propTypes = {
    updateState: PropTypes.object,
    success: PropTypes.bool.isRequired,
    ongoing: PropTypes.bool.isRequired,
    error: PropTypes.object,
    setSuccess: PropTypes.func.isRequired,
    setOngoing: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired,
  }

  componentWillReceiveProps({ updateState }) {
    const {
      updateState: prevUpdateState,
      setOngoing,
      setSuccess,
      setError,
    } = this.props
    if (updateState && updateState !== prevUpdateState) {
      setOngoing(updateState.ongoing)
      setError(updateState.error)
      if (updateState.success && !prevUpdateState.success) {
        setSuccess(true)
        setTimeout(function() {
          setSuccess(false)
        }, 2000)
      }
    }
  }

  render() {
    const { ongoing, success, error } = this.props

    const className = classNames(
      'flexbox flexbox-align-center font-weight-large transition',
      {
        green: ongoing || success,
        transparent: ongoing,
        opaque: success,
      }
    )
    return (
      <div className={className}>
        {ongoing && <div className="update-spinner margin-right-small" />}
        {ongoing && 'Saving...'}
        {success &&
          !ongoing && (
            <div className="flexbox flexbox-align-center">
              <Icons.CheckMarkIcon
                className="todo-block-check-in green margin-right-small"
                size={14}
              />
              <span>Saved !</span>
            </div>
          )}
        {error && error.message}
      </div>
    )
  }
}

export default compose(
  withState('ongoing', 'setOngoing', false),
  withState('success', 'setSuccess', false),
  withState('error', 'setError', null)
)(UpdateStatus)
